var map = {
	"./01_get_Query_Invited_Users.json": "zsZ4",
	"./02_get_Daily_Commission_Query.json": "Gwkw",
	"./03_get_Query_agent_user_nformation.json": "P9RC",
	"./04_get_Query_the_deposit_details.json": "7XUQ",
	"./05_get_Query_API_transaction_commission.json": "IoyB",
	"./06_get_Query_partner_information.json": "8au9",
	"./07_get_referral_code_commission.json": "ZspE",
	"./08_get_Query_agent_superior_check.json": "YnmZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tepN";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/agent/api/agent \.json$
// module id = tepN
// module chunks = 3